import { ReactNode } from 'react';

import { HistoryTabGroup } from '../../constants';
import DesktopHistoryTab from './desktop-history-tab';
import MobileHistoryTab from './mobile-history-tab';

interface Props {
  historyTabGroup: HistoryTabGroup;
  isMobile: boolean;
  title: ReactNode;
}

const HistoryTab = ({ historyTabGroup, isMobile, title }: Props) => {
  if (isMobile) return <MobileHistoryTab historyTabGroup={historyTabGroup} />;
  return <DesktopHistoryTab historyTabGroup={historyTabGroup} title={title} />;
};

export default HistoryTab;
